import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Group_1 from "../../assets/images/Group_1.png"
import FeeMonk_HighRes_Logo from "../../assets/images/FeeMonk_HighRes_Logo.png";
import psib from "../../assets/images/psib.png";
import datagami from "../../assets/images/DG-Logo.png"
import ips from "../../assets/images/Icon-Public-school-logo.png"
import agi from "../../assets/images/agi.png"
import fundzpe from "../../assets/images/fundz-pe-logo.png";
import whatsapp from "../../assets/images/whatsapp.png";
import "./index.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { userService } from "./UserServices.js";

function Index() {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [timer, setTimer] = useState(0);
  const [source, setSource] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const otpSubmitted = useRef(false);

  if (window?.location?.href?.split("?")?.length > 1) {
    sessionStorage
      .setItem("instituteName", window?.location?.href?.split("?")[1])
      ?.split("=");
  }

  // Handle source detection from URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = urlParams.get('referrer');
    
    if (referrer) {
      const referrerPath = referrer.split('/').pop(); 
      console.log('User navigated from:', referrerPath);
      if(referrerPath === "isb" || referrerPath === "ivi"){
        sessionStorage.setItem("source","ISBH")
      }else if(referrerPath === "psib"){
        sessionStorage.setItem("source","Professional School of Indian Banking")
      }else if(referrerPath === "ips"){
        sessionStorage.setItem("source","Icon Public School")
      }
      else if(referrerPath === "t-hub"){
        sessionStorage.setItem("source","T-hub")
      }
      else if(referrerPath === "agi"){
        sessionStorage.setItem("source","Avinash College of Commerce")
      }
      else if(referrerPath === "datagami"){
        sessionStorage.setItem("source","Datagami Technology Services Private Limited")
      }
      setSource(referrerPath)
    } else {
      console.log('No referrer path information available');
    }
  }, []);

  // Handle countdown timer for OTP resend
  useEffect(() => {
    let timerInterval;
    if (timer > 0) {
      timerInterval = setInterval(() => {
        setTimer((old) => old - 1);
      }, 1000);
    }
    return () => clearInterval(timerInterval);
  }, [timer]);

  // Initialize auto OTP reading when OTP is sent
  useEffect(() => {
    if (otpSent) {
      readOTPAutomatically();
      // Reset the submitted flag when sending a new OTP
      otpSubmitted.current = false;
    }
  }, [otpSent]);

  // Handle OTP submission when enteredOtp state is updated by auto-reading
  useEffect(() => {
    // Only proceed if:
    // 1. We have a valid OTP
    // 2. OTP has been sent
    // 3. We're not already in the process of submitting
    // 4. The OTP hasn't been submitted yet
    if (enteredOtp?.length === 6 && otpSent && !isSubmitting && !otpSubmitted.current) {
      // Check if this was triggered by auto-reading
      // Auto-reading sets the value directly without user input events
      const isAutoFilled = document.activeElement !== document.querySelector('input[type="tel"][maxLength="4"]');
      
      if (isAutoFilled) {
        handleOtpSubmit();
      }
    }
  }, [enteredOtp, otpSent, isSubmitting]);

  const saveDataToLS = (data, auth_token) => {
    sessionStorage.setItem(
      "feemonk_data",
      JSON.stringify({
        user_status: data?.status,
        mob: data?.mobile,
        value: auth_token,
      })
    );
  };

  const authenticate = (auth_token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${auth_token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/summary`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        console.log(result?.data?.status);

        saveDataToLS(result?.data, auth_token);

        if (result?.data?.status === "Admin") {
          return navigate(`/upload`);
        }

        if (
          result?.data?.status === "New" ||
          result?.data?.status === "Edited"
        ) {
          return navigate(`/admin-form`);
        }
        if (
          result?.data?.status === "Received" ||
          result?.data?.status === "CoapplicantSubmitted"
        ) {
          return navigate(`/thank-you`);
        }

        if (result?.data?.status === "Coapplicant") {
          return navigate(`/admin-form?coapp=true`);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleResendOtp = (event) => {
    event.preventDefault();
    if (mobileNumber?.length !== 10) {
      setMobileError("Please enter a valid 10-digit mobile number");
      return;
    }

    setTimer(45);
    sessionStorage.setItem("mob", mobileNumber);

    const payLoad = {
      mobile: mobileNumber,
      source: source || "apply-form"
    };

    try {
      userService.loginApi("/login/send-otp", payLoad);
      setOtpSent(true);
      setMobileError("");
      // Reset OTP and submitted flag when resending
      setEnteredOtp("");
      otpSubmitted.current = false;
    } catch (error) {
      console.error("Error while sending OTP:", error);
      alert("Error while sending OTP!!!");
    }
  };

  const submitForm = async (event) => {
    event.preventDefault();
    if (mobileNumber?.length !== 10) {
      setMobileError("Please enter a valid 10-digit mobile number");
      return;
    }

    sessionStorage.setItem("mob", mobileNumber);

    const payLoad = {
      mobile: mobileNumber,
      source: source || "apply-form"
    };

    try {
      await userService.loginApi("/login/send-otp", payLoad);
      setOtpSent(true);
      setTimer(45);
      setMobileError("");
      // Reset OTP and submitted flag when sending new OTP
      setEnteredOtp("");
      otpSubmitted.current = false;
    } catch (error) {
      console.error("Error while sending OTP:", error);
      alert("Error while sending OTP!!!");
    }
  };

  const handleOtpSubmit = async () => {
    // Prevent duplicate submissions
    if (otpSubmitted.current || isSubmitting) {
      return;
    }

    if (enteredOtp?.length !== 6) {
      alert("Please enter a valid 6-digit OTP");
      return;
    }

    setIsSubmitting(true);
    otpSubmitted.current = true;

    const payLoad = {
      mobile: sessionStorage.getItem("mob"),
      otp: enteredOtp,
    };

    try {
      console.log("Calling verify-otp API");
      const response = await userService.submitOtpApi("/login/verify-otp", payLoad);

      if (response.message === "Invalid OTP") {
        alert("Invalid OTP. Please try again.");
        // Reset the flag to allow resubmission
        otpSubmitted.current = false;
      } else if (response.data?.message === "Successful") {
        sessionStorage.setItem("token", response?.data?.data);
        authenticate(response?.data?.data);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("Failed to verify OTP. Please try again.");
      // Reset the flag to allow resubmission
      otpSubmitted.current = false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitOtp = (event) => {
    event.preventDefault();
    handleOtpSubmit();
  };

  const readOTPAutomatically = () => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          if (otp && otp.code) {
            setEnteredOtp(otp.code);
            // Auto-submission is handled by the useEffect hook
          }
        })
        .catch((err) => {
          console.log("Web OTP not supported or failed to read:", err);
        });

      // Abort the controller after 60 seconds
      setTimeout(() => ac.abort(), 60000);
    }
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and max 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setMobileNumber(value);
      setMobileError("");
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and max 4 digits
    if (/^\d{0,6}$/.test(value)) {
      setEnteredOtp(value);
    }
  };

  return (
    <>
      <div className="login-form-container">
        <div className="login-background">
          <img src={Group_1} className="login-image" alt="login" />
          <img
            src={FeeMonk_HighRes_Logo}
            className="feemonk-image"
            alt="website logo"
          />

          <p className="caption">
            Simplified education fee payments & fiscal management <br />
          </p>
        </div>
        
        <div className="login-background-mobile" style={{padding:'1em'}}>
          {(sessionStorage.getItem("source") === "Professional School of Indian Banking" ||  
              sessionStorage.getItem("source") === "Icon Public School" || 
              sessionStorage.getItem("source") === "Avinash College of Commerce" || sessionStorage.getItem("source") === "Datagami Technology Services Private Limited") ? (
            <>
              {(sessionStorage.getItem("source") === "Professional School of Indian Banking" ||  
                sessionStorage.getItem("source") === "Icon Public School" || 
                sessionStorage.getItem("source") === "Avinash College of Commerce" || sessionStorage.getItem("source") === "Datagami Technology Services Private Limited") && 
                <img src={fundzpe} style={{height:'3em',width:'9em'}} alt="FundzPE" />}
              {sessionStorage.getItem("source") === "Professional School of Indian Banking" &&  
                <img src={psib} style={{height:'6em',width:'7em'}} alt="PSIB" />}
              {sessionStorage.getItem("source") === "Icon Public School" &&  
                <img src={ips} style={{height:'6em',width:'7em'}} alt="IPS" />}
              {sessionStorage.getItem("source") === "Avinash College of Commerce" &&  
                <img src={agi} style={{height:'3.5em',width:'9em'}} alt="AGI" />}
              {sessionStorage.getItem("source") === "Datagami Technology Services Private Limited" &&  
                <img src={datagami} style={{height:'4.5em',width:'9em'}} alt="DGM" />}
            </>
          ) : (
            <>
              <img
                src={FeeMonk_HighRes_Logo}
                className="feemonk-image-mobile m-auto"
                alt="website logo"
              />
            </>
          )}  
        </div>
        
        {/* Desktop Form */}
        <form className="form-container">
          <div style={{marginTop:'-20%',display:'flex',justifyContent:'space-between',marginLeft:'20%',paddingBottom:'7%'}}>
            {(sessionStorage.getItem("source") === "Professional School of Indian Banking" ||  
              sessionStorage.getItem("source") === "Icon Public School" || 
              sessionStorage.getItem("source") === "Avinash College of Commerce" || sessionStorage.getItem("source") === "Datagami Technology Services Private Limited") && 
              <img src={fundzpe} style={{height:'4em',width:'12em'}} alt="FundzPE" />}
            {sessionStorage.getItem("source") === "Professional School of Indian Banking" &&  
              <img src={psib} style={{height:'6em',width:'7em',marginBottom:'2em',marginTop:'-3%'}} alt="PSIB" />}
            {sessionStorage.getItem("source") === "Icon Public School" &&  
              <img src={ips} style={{height:'6em',width:'9em',marginBottom:'2em',marginTop:'-3.5%'}} alt="IPS" />}
            {sessionStorage.getItem("source") === "Avinash College of Commerce" &&  
              <img src={agi} style={{height:'3.5em',width:'9em'}} alt="AGI" />}
              {sessionStorage.getItem("source") === "Datagami Technology Services Private Limited" &&  
              <img src={datagami} style={{height:'5em',width:'9em'}} alt="DGM" />}
          </div>
          
          <p className="started">To get started</p>
          <h3 className="login">Log In</h3>

          <div className="input-container">
            <p
              className="input-p"
              style={{
                color: "#667085",
                marginLeft: "20%",
              }}
            >
              Enter Registered Mobile
            </p>
            <input
              type="tel"
              placeholder="Enter 10 digit Mobile Number"
              className="email-input-filed"
              value={mobileNumber}
              onChange={handleMobileNumberChange}
              maxLength={10}
              aria-label="Mobile Number"
              inputMode="tel"
            />
            
            {otpSent && (
              <small
                className="otp-resend"
                onClick={timer > 0 ? null : handleResendOtp}
              >
                {timer > 0 ? `Didn't receive OTP? Wait for ${timer} seconds and hit ` : ""}
                <strong
                  style={{
                    color: timer > 0 ? "grey" : "blue",
                    cursor: timer > 0 ? "not-allowed" : "pointer",
                  }}
                >
                  <u>Resend OTP</u>
                </strong>
              </small>
            )}
            {mobileError && <div className="error">{mobileError}</div>}
          </div>

          {otpSent && (
            <div className="input-container">
              <p
                className="input-p"
                style={{
                  color: "#667085",
                  marginLeft: "20%",
                }}
              >
                OTP
              </p>
              <input
                type="tel"
                className="password-input-filed"
                value={enteredOtp}
                onChange={handleOtpChange}
                placeholder="Enter 6 digit OTP"
                maxLength={6}
                aria-label="OTP"
                inputMode="numeric"
                autoComplete="one-time-code"
              />
            </div>
          )}

          <div className="buttons-container1">
            {!otpSent ? (
              <button
                type="button"
                className="login-button"
                onClick={submitForm}
                disabled={mobileNumber?.length !== 10 || isSubmitting}
                style={{
                  backgroundColor: mobileNumber?.length === 10 && !isSubmitting ? "#d32028" : "gray",
                }}
              >
                Get OTP
              </button>
            ) : (
              <button
                type="button"
                className="login-button"
                onClick={submitOtp}
                disabled={enteredOtp?.length !== 6 || isSubmitting || otpSubmitted.current}
                style={{
                  backgroundColor: enteredOtp?.length === 6 && !isSubmitting && !otpSubmitted.current ? "#d32028" : "gray",
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            )}
          </div>
        </form>
        
        {/* Mobile Form */}
        <form className="form-container-mobile">
          {(sessionStorage.getItem("source") === "Professional School of Indian Banking" ||  
            sessionStorage.getItem("source") === "Icon Public School" ||  
            sessionStorage.getItem("source") === "Avinash College of Commerce") && (
            <img
              src={FeeMonk_HighRes_Logo}
              className="feemonk-image-mobile m-auto"
              alt="website logo"
            />
          )}
        
          <p className="started-mobile">To get started</p>
          <p className="login-mobile">Log In</p>

          <div className="login-mobile-inner-container">
            <div className="input-container-mobile">
              <label className="input-label-mobile">
                <span className="enter-mobile-number-label" style={{ color: "#667085" }}>
                  Enter Registered Mobile
                </span>
              </label>
              <input 
                type="tel"
                placeholder="Enter 10 digit Mobile Number"
                className="email-input-filed-mobile"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                maxLength={10}
                aria-label="Mobile Number"
                inputMode="tel"
              />

              {otpSent && (
                <small
                  className="otp-resend-mobile"
                  onClick={timer > 0 ? null : handleResendOtp}
                >
                  {timer > 0 ? <p>{`Didn't receive OTP? Wait for ${timer} seconds and hit `}</p> : ""}
                  <strong
                    style={{
                      color: timer > 0 ? "grey" : "blue",
                      cursor: timer > 0 ? "not-allowed" : "pointer",
                    }}
                  >
                    <u>Resend OTP</u>
                  </strong>
                </small>
              )}
              {mobileError && <div className="error-mobile">{mobileError}</div>}
            </div>

            {otpSent && (
              <div className="input-container-mobiles d-flex flex-column mt-4">
                <span className="mb-1 ml-1" style={{ color: "#667085", fontSize: "12px" }}>OTP</span>
                <input
                  type="tel"
                  placeholder="Enter OTP"
                  className="password-input-filed-mobile"
                  value={enteredOtp}
                  onChange={handleOtpChange}
                  maxLength={6}
                  aria-label="OTP"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                />
              </div>
            )}
          </div>

          <div className="buttons-container1-mobile">
            {!otpSent ? (
              <button
                type="button"
                className="login-button-mobile"
                onClick={submitForm}
                disabled={mobileNumber?.length !== 10 || isSubmitting}
                style={{
                  backgroundColor: mobileNumber?.length === 10 && !isSubmitting ? "#d32028" : "gray",
                }}
              >
                Get OTP
              </button>
            ) : (
              <button
                type="button"
                className="login-button-mobile"
                onClick={submitOtp}
                disabled={enteredOtp?.length !== 6 || isSubmitting || otpSubmitted.current}
                style={{
                  backgroundColor: enteredOtp?.length === 6 && !isSubmitting && !otpSubmitted.current ? "#d32028" : "gray",
                }}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
}

export default Index;